import { InjectionToken, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { buildUrl, isDefined } from '@trimble-gcs/common';
import { Observable, combineLatest, filter, map, take } from 'rxjs';
import { AppState } from '../app-state/app.state';

export const GET_SCAN_PROJECT_URL = new InjectionToken<(path: string) => Observable<string>>(
  'GetScanProjectUrl',
  {
    factory: () => {
      const store = inject(Store);

      return (path: string) => {
        const region$ = store.select(AppState.projectRegion).pipe(filter(isDefined));
        const project$ = store.select(AppState.project).pipe(filter(isDefined));

        return combineLatest([region$, project$]).pipe(
          map(([region, project]) => buildUrl(region.scandata.url, `/projects/${project.id}`)),
          map((baseUrl) => buildUrl(baseUrl, path)),
          take(1),
        );
      };
    },
  },
);
